<section class="section" *ngIf="_faqData" [class.white-100]="isWhiteBg">
  <div
    class="justfy-item-c"
    [class.section-container]="!isInside"
    [class.section-container-inside]="isInside"
  >
    <h2 class="section-heading mar-b-48">
      {{ _faqData?.content?.content[0]?.content[0]?.value }}
    </h2>
    <div class="faq-container" [ngClass]="customClass ? customClass : ''">
      <ng-container
        *ngFor="let explandable of _faqData?.component1; let i = index"
      >
        <div
          class="faq-open"
          (click)="onMouseOverConvert(i)"
          [ngClass]="activePanelIds === i ? 'open' : ''"
        >
          <div class="faq-open-question">
            {{
              explandable?.fields?.richTextTitle?.content[0]?.content[0]?.value
            }}
            <img
              class="ico-faq"
              src="../../../../../assets/images/downArrow.svg"
            />
          </div>

          <div
            class="faq-open-answer"
            [innerHtml]="explandable.fields.description | toHtml"
          ></div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
